var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPpt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.56769 0H13.0233L18 5.03252V19.4382C18 19.7464 17.7502 19.9962 17.4421 19.9962H2.56769C2.25956 19.9962 2.00977 19.7464 2.00977 19.4382V0.557929C2.00977 0.249796 2.25956 0 2.56769 0Z",
    fill: "#FF7A45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0234 0V4.47459C13.0234 4.78272 13.2732 5.03252 13.5814 5.03252H18.0002L13.0234 0Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5276 9.24333C13.7014 9.42104 13.7932 9.67666 13.7932 10.0558C13.7932 10.435 13.7014 10.6906 13.5276 10.8683C13.3421 11.0581 13.0278 11.1991 12.5634 11.2721H5.66977C5.23838 11.2721 4.88867 11.6218 4.88867 12.0532V15.557C4.88867 15.9884 5.23838 16.3381 5.66977 16.3381C6.10116 16.3381 6.45087 15.9884 6.45087 15.557V12.8343H12.6216C12.6585 12.8343 12.6954 12.8317 12.732 12.8265C14.4006 12.5881 15.3554 11.6114 15.3554 10.0558C15.3554 8.50026 14.4006 7.52355 12.732 7.2852C12.6954 7.27997 12.6585 7.27735 12.6216 7.27734H5.66977C5.23838 7.27734 4.88867 7.62705 4.88867 8.05844C4.88867 8.48983 5.23838 8.83954 5.66977 8.83954H12.5634C13.0278 8.91254 13.3421 9.05354 13.5276 9.24333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.2beed0711da3b7268fda5935a927c031.svg";
export { ForwardRef as ReactComponent };